<template>
  <div class="editor-content-video__edit-wrapper">
    <EditorContentEditable
      class="editor-content-video__link"
      :contenteditable="edit"
      placeholder="Ссылка"
      :class="{ edit }"
      :text="src"
    ></EditorContentEditable>
    <EditorEditButton v-if="!edit" icon="editor/setting" @click="allowEdit" />
    <EditorEditButton v-else icon="editor/apply" @click="accept" />
    <EditorEditButton icon="editor/delete" @click="emit('delete')" />
  </div>
</template>

<script setup>
defineProps({
  src: { type: String, default: '' },
});
const emit = defineEmits(['update:src', 'delete']);
const toast = useToast();

const edit = ref(false);
const srcRef = ref(null);

const allowEdit = () => {
  edit.value = true;
};

const accept = () => {
  const text = srcRef.value.textContent;

  if (!text || !text.includes('https')) {
    toast.error('Введите валидную ссылку');
    return;
  }

  edit.value = false;
  emit('update:src', text);
};
</script>
